import { render, staticRenderFns } from "./FModalBody.vue?vue&type=template&id=367d4bf8&"
import script from "./FModalBody.vue?vue&type=script&lang=js&"
export * from "./FModalBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports